import jwtDecode from "jwt-decode";

export const validateToken = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if(!user) {
        return false;
    }
    return !!jwtDecode(user.accessToken).scope.includes('admin');
};
